import { render } from "./dailysalesmonitoring.vue?vue&type=template&id=1645a718"
import script from "./dailysalesmonitoring.vue?vue&type=script&lang=js"
export * from "./dailysalesmonitoring.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__